var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center",attrs:{"disabled":_vm.loading || _vm.disabled}},[(_vm.loading)?_c('div',{staticClass:"btn-spinner mr-2"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }